module.exports = __webpack_public_path__ + "static/FSD-2-HH-f99d1f72702f9122b02d3c17864d24cc.jpg";